import React from "react";
import { RCCGrid, RCCIcon } from "react-common-components";
import { Link, useHistory } from "react-router-dom";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import Container from "./styles";

const PageNoPermission: React.FC = () => {
	const {superUser, businessGroup} = useAuth();
	const { translate } = useTranslation();
	const history = useHistory();
	return (
		<Container>
			<Title color="purple" size="xl" bold marginBottom={16}>
                403 - {translate("Você não tem acesso a página requisitada")}
			</Title>
			<RCCGrid container item alignItems="center" justifyContent="center">
				<Title color="purple">
					{translate("Para acessá-la é necessario estar num plano contratual que a permite")}
				</Title>
			</RCCGrid>
			{superUser && businessGroup.efa001Id === 1 && (
				<RCCGrid container item alignItems="center" justifyContent="center" style={{margin: "1rem 0"}}>
					<Title color="purple" bold >
						<Link to="/permissions">
							{translate("Clique aqui para navegar para a tela de permissões")}
						</Link>
					</Title>
				</RCCGrid>
			)}
			<RCCGrid container item alignItems="center" justifyContent="center" style={{gap: "2rem"}}>
				<Title color="purple" size="sm" onClick={() => history.goBack()}>
					<RCCIcon name="arrowBack" style={{ marginRight: "0.125rem" }}/>
					{translate("Voltar")}
				</Title>
				<Link to="/">
					<Title color="purple" size="sm">
						<RCCIcon name="arrowBack" />
						<RCCIcon name="arrowBack" style={{ marginRight: "0.125rem" }}/>
						{translate("Voltar ao início")}
					</Title>
				</Link>
			</RCCGrid>
		</Container>
	);
};

export default PageNoPermission;
